import request from '@/utils/request'

const resetCurrentUser = () => {
  return request({
    url: `${process.env.VUE_APP_GOOGLE_API}/student-account/reset-current-user`,
    method: 'post'
  })
} 

export default {
  resetCurrentUser
}
